import { type DefaultBodyType, HttpResponse, type PathParams } from 'msw'

/** The mock session cookie every authenticated handler checks for. */
export const COOKIE_NAME = 'JSESSIONID'
export const COOKIE_VALUE = 'test-session-cookie'
export const COOKIE_STRING = `${COOKIE_NAME}=${COOKIE_VALUE}`

export type Resolver = (info: {
  request: Request
  params: PathParams
  cookies: Record<string, string>
}) => HttpResponse<DefaultBodyType> | Promise<HttpResponse<DefaultBodyType>> | undefined

/** Answers as `resolver` does for a signed-in browser, and as the mock auth gate does (499) otherwise. */
export const signedIn =
  (resolver: Resolver): Resolver =>
  info =>
    COOKIE_NAME in info.cookies ? resolver(info) : new HttpResponse(null, { status: 499 })
